module.exports = __webpack_public_path__ + "assets/img/home-typical-scenarios-en.5934a6c0.png";